// components/ThreeLineTicker.tsx
import Marquee from "react-fast-marquee";
import ResponsiveCDNImage from "../../../components/common/image/responsive-cdn-image";

const images1 = [
  "https://cdn-mahi.com/1748522896323-%E1%84%83%E1%85%A1%E1%84%8B%E1%85%AE%E1%86%AB%E1%84%85%E1%85%A9%E1%84%83%E1%85%B3%20%281%29.jpeg",
  "https://cdn-mahi.com/1748496148615-IMG_1167.jpeg",
  "https://cdn-mahi.com/1748488832401-IMG_0183.png",
  "https://cdn-mahi.com/1748470361337-IMG_0683.jpeg",
  "https://cdn-mahi.com/1748438611757-1000030056.jpg",
  "https://cdn-mahi.com/1748416122087-%E1%84%83%E1%85%A1%E1%84%8B%E1%85%AE%E1%86%AB%E1%84%85%E1%85%A9%E1%84%83%E1%85%B3.jpeg",
  "https://cdn-mahi.com/1748266353171-451812503_4846034074",
  "https://cdn-mahi.com/1748246351668-1000002664.jpg",
];

const images2 = [
  "https://cdn-mahi.com/1748245206142-IMG_8475.jpeg",
  "https://cdn-mahi.com/1748247390711-IMG_2177.jpg",
  "https://cdn-mahi.com/1748241223320-470035538_2041886632",
  "https://cdn-mahi.com/1748252922507-IMG_1709.jpeg",
  "https://cdn-mahi.com/1748145217586-IMG_5572.jpeg",
  "https://cdn-mahi.com/1748066375223-IMG_6111.jpeg",
  "https://cdn-mahi.com/1748008290365-image.jpg",
  "https://cdn-mahi.com/1747994753169-%E1%84%83%E1%85%A1%E1%84%8B%E1%85%AE%E1%86%AB%E1%84%85%E1%85%A9%E1%84%83%E1%85%B3.jpeg",
];

const images3 = [
  "https://cdn-mahi.com/1747984418768-469824278_5442478754",
  "https://cdn-mahi.com/1747970351232-IMG_8836.jpeg",
  "https://cdn-mahi.com/1747968952123-baker%2520poster1_VSCO",
  "https://cdn-mahi.com/1747889716039-IMG_4820.jpeg",
  "https://cdn-mahi.com/1747820998756-%E1%84%83%E1%85%A1%E1%84%8B%E1%85%AE%E1%86%AB%E1%84%85%E1%85%A9%E1%84%83%E1%85%B3.jpeg",
  "https://cdn-mahi.com/1747798523485-IMG_7961.jpeg",
  "https://cdn-mahi.com/1747639271875-IMG_6568.jpeg",
  "https://cdn-mahi.com/1747400799511-IMG_1711.jpeg",
  "https://cdn-mahi.com/1747401809208-%E1%84%83%E1%85%A1%E1%84%8B%E1%85%AE%E1%86%AB%E1%84%85%E1%85%A9%E1%84%83%E1%85%B3.jpeg",
  "https://cdn-mahi.com/1747383778174-393369832_1123045721",
  "https://cdn-mahi.com/1747379649565-IMG_2343.jpeg",
  "https://cdn-mahi.com/1747370560548-C8AC2816-87B4-4054-B",
  "https://cdn-mahi.com/1747369530584-1000075408.jpg",
  "https://cdn-mahi.com/1747368563674-1000079295.png",
  "https://cdn-mahi.com/1747308354210-481926807_1796299491",
];

export default function ThreeLineTicker() {
  return (
    <div className="flex flex-col gap-2">
      {/* 위 줄 - 오른쪽 방향 */}
      <Marquee direction="right" speed={20} gradient={false}>
        {images1.map((src, idx) => (
          <ResponsiveCDNImage
            key={`image-${idx}`}
            src={src}
            className="h-24 w-24 rounded-lg mx-2"
            alt={`image-${idx}`}
          />
        ))}
      </Marquee>

      {/* 가운데 줄 - 왼쪽 방향 */}
      <Marquee direction="left" speed={20} gradient={false}>
        {images2.map((src, idx) => (
          <ResponsiveCDNImage
            key={`image2-${idx}`}
            src={src}
            className="h-24 w-24 rounded-lg mx-2"
            alt={`image-${idx}`}
          />
        ))}
      </Marquee>

      {/* 아래 줄 - 오른쪽 방향 */}
      <Marquee direction="right" speed={20} gradient={false}>
        {images3.map((src, idx) => (
          <ResponsiveCDNImage
            key={`image3-${idx}`}
            src={src}
            className="h-24 w-24 rounded-lg mx-2"
            alt={`image-${idx}`}
          />
        ))}
      </Marquee>
    </div>
  );
}
